import React, { useEffect, useState } from 'react';

import {
  withOrientationChange,
} from 'react-device-detect';

import ChatComponent from '../Chat';
import MediaPlayer from '../MediaPlayer';
import appStore from '../../store';

const ActiveCallScreen = () => {
  // eslint-disable-next-line no-unused-vars
  const [inScreenShare, setInScreenShare] = useState(false);
  const [operatorOnMobile, setOperatorOnMobile] = useState(false);
  const [operator, setOperator] = useState(null);
  const [videoActive, setVideoActive] = useState(false);
  const activeTicket = appStore.useState((s) => s.activeTicket);
  const ovdSession = appStore.useState((s) => s.ovdSession);
  const subscribers = appStore.useState((s) => s.ovdSubscribers);

  const [showChat, setShowChat] = useState(false);

  useEffect(() => {
    if (ovdSession !== null) {
      ovdSession.on('streamPropertyChanged', (event) => {
        // eslint-disable-next-line no-unused-vars
        const { changedProperty, newValue } = event;
        console.log('streamPropertyChanged', event);
      });
    }
  }, [ovdSession]);

  useEffect(() => {
    if (subscribers.length > 0) {
      setOperator(subscribers[0]);
    }
  }, [subscribers]);

  useEffect(() => {
    if (operator) {
      const { stream: { videoDimensions, videoActive: operatorVideoActive } } = operator;
      console.log('operator', operator);
      setVideoActive(operatorVideoActive);

      const { width, height } = videoDimensions;
      console.log('width, height === ', width, height);

      if (width >= 1920 || height >= 1920) {
        setInScreenShare(true);
        setShowChat(false);
      } else {
        setInScreenShare(false);
      }
      if (height > width) setOperatorOnMobile(true);
    }
  }, [operator]);

  return (
    <div className="active-call__screen">
      <div className="active-call__info">
        <p>
          Вас обслуживает:
          <strong>{activeTicket.operatorName}</strong>
        </p>
      </div>
      <MediaPlayer
        inScreenShare={inScreenShare}
        setShowChat={setShowChat}
        showChat={showChat}
        videoActive={videoActive}
        operatorOnMobile={operatorOnMobile}
      />
      <ChatComponent inScreenShare={inScreenShare} showChat={showChat} />
    </div>
  );
};
export default withOrientationChange(ActiveCallScreen);
